// extracted by mini-css-extract-plugin
module.exports = {"collapser":"Collapser_collapser__POc_D","collapser_active":"Collapser_collapser_active__cbSnm","collapser_show_more":"Collapser_collapser_show_more__2Iqyj"};